module.exports = ".modal-resubscribe-client {\n  z-index: 99999999; }\n  .modal-resubscribe-client__background {\n    display: none;\n    position: fixed;\n    z-index: 99999998;\n    background: rgba(0, 0, 0, 0.5);\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100vw;\n    height: 100vh;\n    cursor: default; }\n  .modal-resubscribe-client.in + .modal-resubscribe-client__background {\n    display: block; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/client/modals/resubscribe-client-modal/resubscribe-client-modal.scss
// module id = ./web/modern/components/client/modals/resubscribe-client-modal/resubscribe-client-modal.scss
// module chunks = 0